module.exports = __webpack_public_path__ + "static/img/ME@3x.64b9eab7.jpg";